export const CONTACT = {
  phones: ["+91 99023 10141", "+91 89710 06663"],
  phonesRaw: ["919902310141", "918971006663"],
  address:
    "Valencia Church Rd, Valencia, Souterpet, Kankanady, Mangaluru, Karnataka 575002",
  addressShort: "Valencia, Kankanady, Mangaluru",
  instagram: "https://www.instagram.com/golden_decor_wedding",
  instagramHandle: "@golden_decor_wedding",
  facebook: "https://www.facebook.com/people/golden-Decor/100054295100758/",
  whatsapp: "https://wa.me/919902310141?text=Hi%20Golden%20Decor%2C%20I%27d%20love%20to%20plan%20an%20event%20with%20you.",
  maps: "https://www.google.com/maps/search/?api=1&query=Valencia+Church+Rd+Kankanady+Mangaluru",
};

export const SERVICES = [
  {
    no: "01",
    title: "Planning & Coordination",
    desc: "End-to-end orchestration of every ritual and moment, so you live the day instead of managing it.",
    intro:
      "Sit back and soak it all in. Our planners map every ritual, vendor and minute into a flawless timeline — so your only job on the big day is to celebrate while we run the show behind the scenes.",
    waText:
      "Hi Golden Decor! I'm interested in your Planning & Coordination service. Could you share the details and availability?",
    image:
      "https://images.unsplash.com/photo-1519741497674-611481863552?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    images: [
      "https://images.unsplash.com/photo-1519741497674-611481863552?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
    accent: "var(--gd-emerald)",
  },
  {
    no: "02",
    title: "Event Decor",
    desc: "Floral ceilings, draped mandaps and tablescapes built to make guests gasp the moment they arrive.",
    intro:
      "Floral ceilings, draped mandaps and statement backdrops. We transform any venue into a world your guests will never forget from the very moment they walk in.",
    waText:
      "Hi Golden Decor! I'd love to discuss Event Decor for my celebration. What themes and packages do you offer?",
    image:
      "https://images.unsplash.com/photo-1744805624954-a6686543c3ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    images: [
      "/decor/palm.jpeg",
      "https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
    accent: "var(--gd-fuchsia)",
  },
  {
    no: "03",
    title: "Concept & Designing",
    desc: "A signature narrative and mood board for your celebration, designed around your story and colours.",
    intro:
      "Every celebration deserves its own signature. We craft a bespoke theme, colour palette and mood board designed entirely around your story — a look that is unmistakably yours.",
    waText:
      "Hi Golden Decor! I want a custom Concept & Design theme for my event. Can we talk through some ideas?",
    image:
      "https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    images: [
      "https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.unsplash.com/photo-1478146896981-b80fe463b330?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
    accent: "var(--gd-marigold)",
  },
  {
    no: "04",
    title: "Sound & Light",
    desc: "Immersive stage lighting, ambient washes and crystal-clear audio engineered for the perfect atmosphere.",
    intro:
      "Immersive stage lighting, ambient washes and crystal-clear sound — engineered by our own technicians to set the perfect mood for every entrance, speech and first dance.",
    waText:
      "Hi Golden Decor! I'd like details on your Sound & Light setup for my event.",
    image:
      "https://images.unsplash.com/photo-1558620013-a08999547a36?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    images: [
      "https://images.unsplash.com/photo-1558620013-a08999547a36?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
    accent: "var(--gd-gold)",
  },
  {
    no: "05",
    title: "Entertainment",
    desc: "Live performers, curated music and show-stopping acts that keep every guest on their feet.",
    intro:
      "Live performers, curated DJs and show-stopping acts. We program entertainment that keeps every guest — young and old — on their feet from the first beat to the last.",
    waText:
      "Hi Golden Decor! I'm looking for Entertainment options for my function. What acts can you arrange?",
    image:
      "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    images: [
      "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
    accent: "var(--gd-fuchsia)",
  },
  {
    no: "06",
    title: "Luxury Cars with Drivers",
    desc: "Chauffeur-driven premium cars, elegantly adorned, for grand entrances and effortless arrivals.",
    intro:
      "Arrive like royalty. Chauffeur-driven premium cars, elegantly adorned, for grand entrances and effortless, comfortable transfers for you and your family.",
    waText:
      "Hi Golden Decor! I'm interested in your Luxury Cars with Drivers. Are they available on my date?",
    image:
      "https://images.pexels.com/photos/13044866/pexels-photo-13044866.jpeg?auto=compress&cs=tinysrgb&w=1200",
    images: [
      "https://images.pexels.com/photos/13044866/pexels-photo-13044866.jpeg?auto=compress&cs=tinysrgb&w=900",
      "https://images.unsplash.com/photo-1503376780353-7e6692767b70?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
    accent: "var(--gd-emerald)",
  },
];

export const waLink = (text) =>
  `https://wa.me/${CONTACT.phonesRaw[0]}?text=${encodeURIComponent(text)}`;

export const GALLERY = [
  {
    src: "https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    label: "Floral Ceiling",
    span: "md:col-span-7 md:row-span-2",
    h: "h-[420px] md:h-full",
  },
  {
    src: "https://images.pexels.com/photos/13156145/pexels-photo-13156145.jpeg?auto=compress&cs=tinysrgb&w=1000",
    label: "The Mandap",
    span: "md:col-span-5",
    h: "h-[300px] md:h-[300px]",
  },
  {
    src: "https://images.pexels.com/photos/13044866/pexels-photo-13044866.jpeg?auto=compress&cs=tinysrgb&w=1000",
    label: "Grand Arrival",
    span: "md:col-span-5",
    h: "h-[300px] md:h-[300px]",
  },
  {
    src: "https://images.unsplash.com/photo-1744805624954-a6686543c3ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    label: "Ceremony Stage",
    span: "md:col-span-4",
    h: "h-[320px]",
  },
  {
    src: "https://images.unsplash.com/photo-1558620013-a08999547a36?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    label: "Sound & Light",
    span: "md:col-span-4",
    h: "h-[320px]",
  },
  {
    src: "https://images.unsplash.com/photo-1519741497674-611481863552?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    label: "Tablescapes",
    span: "md:col-span-4",
    h: "h-[320px]",
  },
  {
    src: "/decor/maroon.webp",
    label: "Mehndi Backdrop",
    span: "md:col-span-6",
    h: "h-[520px]",
  },
  {
    src: "/decor/palm.jpeg",
    label: "Backwater Mandap",
    span: "md:col-span-6",
    h: "h-[520px]",
  },
];

export const VIDEOS = [
  {
    src: "/videos/candles.mp4",
    poster:
      "https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    title: "Candlelit Romance",
    tag: "Decor",
  },
  {
    src: "/videos/bokeh.mp4",
    poster:
      "https://images.unsplash.com/photo-1558620013-a08999547a36?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    title: "Golden Ambience",
    tag: "Sound & Light",
  },
  {
    src: "/videos/bouquet.mp4",
    poster:
      "https://images.unsplash.com/photo-1744805624954-a6686543c3ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    title: "Floral Detailing",
    tag: "Concept",
  },
];

export const HERO_VIDEO = "/videos/candles.mp4";

export const HERO_IMAGES = [
  "/hero/h1b.jpeg",
  "/hero/h1.jpeg",
  "/hero/h5.webp",
  "/hero/h2.jpeg",
  "/hero/h4.webp",
];
